import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';

export default function TermsConditions() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <Navbar />
      <main className="pt-28 pb-20">
        <div className="container mx-auto px-6 md:px-12 max-w-4xl">
          <h1 className="text-3xl md:text-5xl font-semibold tracking-tight mb-6">
            Conditions g&eacute;n&eacute;rales de vente (CGV)
          </h1>
          <p className="text-muted-foreground mb-10 leading-relaxed">
            Les pr&eacute;sentes conditions g&eacute;n&eacute;rales de vente (ci-apr&egrave;s &laquo;&nbsp;CGV&nbsp;&raquo;) 
            r&eacute;gissent l&rsquo;ensemble des prestations de services propos&eacute;es par FastTask &agrave; ses clients 
            professionnels et particuliers. Elles sont &eacute;tablies conform&eacute;ment aux articles L441-1 et suivants 
            du Code de commerce et aux articles L111-1 et suivants du Code de la consommation.
          </p>
          <p className="text-xs text-muted-foreground/70 mb-10">
            Derni&egrave;re mise &agrave; jour&nbsp;: 18 mars 2025
          </p>

          <section className="space-y-10 text-sm md:text-base leading-relaxed text-muted-foreground">

            {/* Article 1 */}
            <div>
              <h2 className="text-foreground text-xl font-semibold mb-2">Article 1 &ndash; Objet et champ d&rsquo;application</h2>
              <p>
                Les pr&eacute;sentes CGV s&rsquo;appliquent &agrave; toutes les prestations de conseil, 
                d&rsquo;int&eacute;gration et d&rsquo;automatisation par intelligence artificielle (IA) 
                fournies par FastTask (ci-apr&egrave;s &laquo;&nbsp;le Prestataire&nbsp;&raquo;) &agrave; tout client 
                professionnel ou consommateur (ci-apr&egrave;s &laquo;&nbsp;le Client&nbsp;&raquo;).
              </p>
              <p className="mt-2">
                Elles couvrent notamment les services d&rsquo;automatisation destin&eacute;s aux secteurs de la 
                restauration, du m&eacute;dical et du retail, ainsi que toute autre prestation propos&eacute;e 
                par le Prestataire.
              </p>
              <p className="mt-2">
                Toute commande de prestation implique l&rsquo;acceptation sans r&eacute;serve des pr&eacute;sentes CGV, 
                qui pr&eacute;valent sur tout autre document du Client, sauf d&eacute;rogation expresse et &eacute;crite.
              </p>
            </div>

            {/* Article 2 */}
            <div>
              <h2 className="text-foreground text-xl font-semibold mb-2">Article 2 &ndash; Identification du Prestataire</h2>
              <ul className="list-none space-y-1 mt-2">
                <li><span className="text-foreground font-medium">Raison sociale&nbsp;:</span> FastTask</li>
                <li><span className="text-foreground font-medium">Adresse&nbsp;:</span> La Marsa, Tunisie</li>
                <li><span className="text-foreground font-medium">Email&nbsp;:</span> contact@fasttask.agency</li>
                <li><span className="text-foreground font-medium">T&eacute;l&eacute;phone&nbsp;:</span> +216 29 275 042 / +216 24 112 051</li>
                <li><span className="text-foreground font-medium">Site web&nbsp;:</span> https://fasttask.agency</li>
              </ul>
            </div>

            {/* Article 3 */}
            <div>
              <h2 className="text-foreground text-xl font-semibold mb-2">Article 3 &ndash; Caract&eacute;ristiques essentielles des services</h2>
              <p>
                Le Prestataire propose des solutions d&rsquo;automatisation par IA comprenant, sans s&rsquo;y limiter&nbsp;:
              </p>
              <ul className="list-disc pl-6 mt-2 space-y-1">
                <li>L&rsquo;audit et le conseil en automatisation des processus m&eacute;tier</li>
                <li>La conception, le d&eacute;veloppement et l&rsquo;int&eacute;gration de solutions IA sur mesure</li>
                <li>L&rsquo;automatisation des r&eacute;servations, de la gestion des stocks et de la relation client (secteur restauration)</li>
                <li>L&rsquo;optimisation de la prise de rendez-vous, la r&eacute;duction des no-shows et l&rsquo;automatisation administrative (secteur m&eacute;dical)</li>
                <li>Les recommandations intelligentes, le suivi des stocks et l&rsquo;automatisation du service client (secteur retail)</li>
                <li>La formation, la maintenance et le support technique associ&eacute;s</li>
              </ul>
              <p className="mt-2">
                Les caract&eacute;ristiques d&eacute;taill&eacute;es de chaque prestation sont pr&eacute;cis&eacute;es 
                dans le devis ou la proposition commerciale valid&eacute;e par le Client.
              </p>
            </div>

            {/* Article 4 */}
            <div>
              <h2 className="text-foreground text-xl font-semibold mb-2">Article 4 &ndash; Commande et acceptation</h2>
              <p>
                Toute prestation fait l&rsquo;objet d&rsquo;un devis d&eacute;taill&eacute; mentionnant la nature 
                des services, les livrables attendus, le calendrier pr&eacute;visionnel et le prix.
              </p>
              <p className="mt-2">
                La commande est r&eacute;put&eacute;e accept&eacute;e lors de la signature du devis par le Client 
                ou de la r&eacute;ception d&rsquo;un bon de commande &eacute;crit, et apr&egrave;s versement 
                de l&rsquo;acompte pr&eacute;vu le cas &eacute;ch&eacute;ant.
              </p>
              <p className="mt-2">
                Les devis &eacute;tablis par le Prestataire ont une dur&eacute;e de validit&eacute; de 30 jours 
                &agrave; compter de leur date d&rsquo;&eacute;mission, sauf mention contraire.
              </p>
            </div>

            {/* Article 5 */}
            <div>
              <h2 className="text-foreground text-xl font-semibold mb-2">Article 5 &ndash; Prix et bar&egrave;me tarifaire</h2>
              <p>
                Les prix des prestations sont indiqu&eacute;s en euros hors taxes (HT). La TVA applicable 
                sera ajout&eacute;e conform&eacute;ment &agrave; la r&eacute;glementation en vigueur.
              </p>
              <p className="mt-2">
                Le bar&egrave;me tarifaire est d&eacute;fini dans le devis ou la proposition commerciale. 
                Les prix peuvent &ecirc;tre fix&eacute;s au forfait ou sur la base d&rsquo;un taux journalier 
                ou horaire, selon la nature de la prestation.
              </p>
              <p className="mt-2 text-foreground font-medium">R&eacute;ductions de prix&nbsp;:</p>
              <p>
                Des remises peuvent &ecirc;tre accord&eacute;es en fonction du volume de la commande 
                ou de la dur&eacute;e de l&rsquo;engagement. Toute r&eacute;duction consentie figure 
                express&eacute;ment sur le devis ou la facture correspondante.
              </p>
              <p className="mt-2">
                Le Prestataire se r&eacute;serve le droit de r&eacute;viser ses tarifs. Les nouveaux tarifs 
                ne s&rsquo;appliquent qu&rsquo;aux commandes post&eacute;rieures &agrave; leur entr&eacute;e en vigueur.
              </p>
            </div>

            {/* Article 6 */}
            <div>
              <h2 className="text-foreground text-xl font-semibold mb-2">Article 6 &ndash; Conditions de r&egrave;glement</h2>
              <p>
                Sauf stipulation contraire dans le devis, les conditions de paiement sont les suivantes&nbsp;:
              </p>
              <ul className="list-disc pl-6 mt-2 space-y-1">
                <li>Un acompte de 30&nbsp;% du montant total est exigible &agrave; la signature du devis</li>
                <li>Le solde est payable &agrave; r&eacute;ception de la facture, avec un d&eacute;lai de paiement de 30 jours &agrave; compter de la date de facturation</li>
              </ul>
              <p className="mt-3">
                Le paiement s&rsquo;effectue par virement bancaire ou tout autre moyen convenu entre les parties.
              </p>

              <p className="mt-3 text-foreground font-medium">P&eacute;nalit&eacute;s de retard&nbsp;:</p>
              <p>
                Conform&eacute;ment &agrave; l&rsquo;article L441-10 du Code de commerce, en cas de retard 
                de paiement, des p&eacute;nalit&eacute;s de retard seront appliqu&eacute;es au taux d&rsquo;int&eacute;r&ecirc;t 
                l&eacute;gal major&eacute; de 10 points, exigibles de plein droit et sans mise en demeure pr&eacute;alable, 
                &agrave; compter du jour suivant la date de r&egrave;glement figurant sur la facture.
              </p>

              <p className="mt-3 text-foreground font-medium">Indemnit&eacute; forfaitaire de recouvrement&nbsp;:</p>
              <p>
                Conform&eacute;ment aux articles L441-10 et D441-5 du Code de commerce, une indemnit&eacute; 
                forfaitaire de 40&nbsp;&euro; pour frais de recouvrement sera due de plein droit en cas de 
                retard de paiement. Lorsque les frais de recouvrement expos&eacute;s sont sup&eacute;rieurs 
                &agrave; ce montant, une indemnisation compl&eacute;mentaire pourra &ecirc;tre demand&eacute;e 
                sur justificatifs.
              </p>
            </div>

            {/* Article 7 */}
            <div>
              <h2 className="text-foreground text-xl font-semibold mb-2">Article 7 &ndash; D&eacute;lais d&rsquo;ex&eacute;cution</h2>
              <p>
                Les d&eacute;lais d&rsquo;ex&eacute;cution des prestations sont indiqu&eacute;s dans le devis 
                &agrave; titre indicatif. Le Prestataire s&rsquo;engage &agrave; mettre en &oelig;uvre tous les 
                moyens raisonnables pour respecter les d&eacute;lais convenus.
              </p>
              <p className="mt-2">
                Un retard dans l&rsquo;ex&eacute;cution ne peut donner lieu &agrave; des dommages-int&eacute;r&ecirc;ts, 
                retenue ou annulation de commande, sauf accord &eacute;crit pr&eacute;alable entre les parties.
              </p>
            </div>

            {/* Article 8 */}
            <div>
              <h2 className="text-foreground text-xl font-semibold mb-2">Article 8 &ndash; R&eacute;ception et validation des livrables</h2>
              <p>
                &Agrave; l&rsquo;issue de chaque phase de la mission ou &agrave; la livraison finale, le Client 
                dispose d&rsquo;un d&eacute;lai de 15 jours pour formuler ses observations ou r&eacute;serves 
                par &eacute;crit. Pass&eacute; ce d&eacute;lai, les livrables sont r&eacute;put&eacute;s 
                accept&eacute;s sans r&eacute;serve.
              </p>
            </div>

            {/* Article 9 */}
            <div>
              <h2 className="text-foreground text-xl font-semibold mb-2">Article 9 &ndash; Droit de r&eacute;tractation</h2>
              <p>
                <span className="text-foreground font-medium">Pour les clients consommateurs&nbsp;:</span> conform&eacute;ment 
                aux articles L221-18 et suivants du Code de la consommation, le Client consommateur 
                dispose d&rsquo;un d&eacute;lai de 14 jours &agrave; compter de la conclusion du contrat pour 
                exercer son droit de r&eacute;tractation, sans avoir &agrave; justifier de motif.
              </p>
              <p className="mt-2">
                Ce droit s&rsquo;exerce par l&rsquo;envoi d&rsquo;un courrier &eacute;lectronique &agrave; 
                contact@fasttask.agency ou par lettre recommand&eacute;e avec accus&eacute; de r&eacute;ception.
              </p>
              <p className="mt-2">
                Toutefois, conform&eacute;ment &agrave; l&rsquo;article L221-28 du Code de la consommation, 
                le droit de r&eacute;tractation ne peut &ecirc;tre exerc&eacute; pour les prestations de services 
                pleinement ex&eacute;cut&eacute;es avant la fin du d&eacute;lai de r&eacute;tractation et dont 
                l&rsquo;ex&eacute;cution a commenc&eacute; avec l&rsquo;accord pr&eacute;alable et expr&egrave;s du consommateur.
              </p>
              <p className="mt-2">
                <span className="text-foreground font-medium">Pour les clients professionnels&nbsp;:</span> le 
                droit de r&eacute;tractation ne s&rsquo;applique pas aux contrats conclus entre professionnels.
              </p>
            </div>

            {/* Article 10 */}
            <div>
              <h2 className="text-foreground text-xl font-semibold mb-2">Article 10 &ndash; Obligations du Client</h2>
              <p>Le Client s&rsquo;engage &agrave;&nbsp;:</p>
              <ul className="list-disc pl-6 mt-2 space-y-1">
                <li>Fournir au Prestataire l&rsquo;ensemble des informations et documents n&eacute;cessaires &agrave; la bonne ex&eacute;cution de la mission</li>
                <li>D&eacute;signer un interlocuteur habilit&eacute; &agrave; valider les &eacute;tapes du projet</li>
                <li>Respecter les d&eacute;lais de validation des livrables</li>
                <li>R&eacute;gler les factures dans les d&eacute;lais convenus</li>
              </ul>
              <p className="mt-2">
                Tout retard ou manquement du Client dans l&rsquo;ex&eacute;cution de ses obligations peut 
                entra&icirc;ner un report proportionnel des d&eacute;lais de livraison, sans que la 
                responsabilit&eacute; du Prestataire puisse &ecirc;tre engag&eacute;e.
              </p>
            </div>

            {/* Article 11 */}
            <div>
              <h2 className="text-foreground text-xl font-semibold mb-2">Article 11 &ndash; Propri&eacute;t&eacute; intellectuelle</h2>
              <p>
                Sauf stipulation contraire, les d&eacute;veloppements r&eacute;alis&eacute;s sp&eacute;cifiquement 
                pour le Client dans le cadre de la mission lui sont c&eacute;d&eacute;s en pleine propri&eacute;t&eacute; 
                apr&egrave;s paiement int&eacute;gral du prix convenu.
              </p>
              <p className="mt-2">
                Les outils, frameworks, m&eacute;thodes et composants g&eacute;n&eacute;riques utilis&eacute;s 
                ou d&eacute;velopp&eacute;s par le Prestataire restent sa propri&eacute;t&eacute; exclusive. 
                Le Client b&eacute;n&eacute;ficie d&rsquo;une licence d&rsquo;utilisation non exclusive 
                et non cessible pour les besoins de son activit&eacute;.
              </p>
            </div>

            {/* Article 12 */}
            <div>
              <h2 className="text-foreground text-xl font-semibold mb-2">Article 12 &ndash; Responsabilit&eacute; et garantie</h2>
              <p>
                Le Prestataire s&rsquo;engage &agrave; ex&eacute;cuter les prestations avec diligence et 
                selon les r&egrave;gles de l&rsquo;art, dans le cadre d&rsquo;une obligation de moyens.
              </p>
              <p className="mt-2">
                La responsabilit&eacute; du Prestataire est limit&eacute;e aux dommages directs et pr&eacute;visibles 
                li&eacute;s &agrave; un manquement prouv&eacute; &agrave; ses obligations contractuelles. En tout 
                &eacute;tat de cause, le montant de l&rsquo;indemnisation ne pourra exc&eacute;der le montant 
                total des sommes effectivement per&ccedil;ues au titre de la commande concern&eacute;e.
              </p>
              <p className="mt-2">
                Le Prestataire ne saurait &ecirc;tre tenu responsable des dommages indirects tels que perte 
                de chiffre d&rsquo;affaires, perte de donn&eacute;es, pr&eacute;judice commercial ou atteinte 
                &agrave; l&rsquo;image.
              </p>
            </div>

            {/* Article 13 */}
            <div>
              <h2 className="text-foreground text-xl font-semibold mb-2">Article 13 &ndash; Confidentialit&eacute;</h2>
              <p>
                Chaque partie s&rsquo;engage &agrave; traiter comme confidentielles toutes les informations 
                techniques, commerciales ou financi&egrave;res communiqu&eacute;es par l&rsquo;autre partie 
                dans le cadre de la mission. Cette obligation subsiste pendant toute la dur&eacute;e du contrat 
                et pendant une p&eacute;riode de 2 ans suivant son terme.
              </p>
            </div>

            {/* Article 14 */}
            <div>
              <h2 className="text-foreground text-xl font-semibold mb-2">Article 14 &ndash; Protection des donn&eacute;es personnelles</h2>
              <p>
                Le Prestataire s&rsquo;engage &agrave; respecter la r&eacute;glementation applicable en 
                mati&egrave;re de donn&eacute;es personnelles, notamment le R&egrave;glement g&eacute;n&eacute;ral 
                sur la protection des donn&eacute;es (RGPD) et la loi Informatique et Libert&eacute;s.
              </p>
              <p className="mt-2">
                Pour plus d&rsquo;informations sur le traitement de vos donn&eacute;es, consultez notre&nbsp;
                <a href="/politique-confidentialite" className="text-[hsl(211,100%,50%)] dark:text-[hsl(211,100%,55%)] hover:underline">
                  politique de confidentialit&eacute;
                </a>.
              </p>
            </div>

            {/* Article 15 */}
            <div>
              <h2 className="text-foreground text-xl font-semibold mb-2">Article 15 &ndash; R&eacute;siliation</h2>
              <p>
                En cas de manquement grave de l&rsquo;une des parties &agrave; ses obligations, l&rsquo;autre 
                partie pourra r&eacute;silier le contrat de plein droit, apr&egrave;s mise en demeure 
                rest&eacute;e infructueuse pendant 15 jours, par lettre recommand&eacute;e avec accus&eacute; 
                de r&eacute;ception.
              </p>
              <p className="mt-2">
                En cas de r&eacute;siliation anticip&eacute;e par le Client hors manquement du Prestataire, 
                les prestations d&eacute;j&agrave; r&eacute;alis&eacute;es restent dues et les acomptes 
                vers&eacute;s sont acquis au Prestataire.
              </p>
            </div>

            {/* Article 16 */}
            <div>
              <h2 className="text-foreground text-xl font-semibold mb-2">Article 16 &ndash; Force majeure</h2>
              <p>
                Aucune des parties ne sera tenue responsable d&rsquo;un retard ou d&rsquo;un d&eacute;faut 
                d&rsquo;ex&eacute;cution r&eacute;sultant d&rsquo;un cas de force majeure tel que d&eacute;fini 
                par l&rsquo;article 1218 du Code civil.
              </p>
            </div>

            {/* Article 17 */}
            <div>
              <h2 className="text-foreground text-xl font-semibold mb-2">Article 17 &ndash; M&eacute;diation et r&egrave;glement des litiges</h2>
              <p>
                <span className="text-foreground font-medium">Pour les clients consommateurs&nbsp;:</span> conform&eacute;ment 
                aux articles L611-1 et suivants du Code de la consommation, en cas de litige non r&eacute;solu 
                &agrave; l&rsquo;amiable, le Client consommateur peut recourir gratuitement &agrave; un m&eacute;diateur 
                de la consommation. Les coordonn&eacute;es du m&eacute;diateur comp&eacute;tent seront communiqu&eacute;es 
                sur simple demande &agrave; contact@fasttask.agency.
              </p>
              <p className="mt-2">
                Le Client consommateur peut &eacute;galement recourir &agrave; la plateforme europ&eacute;enne 
                de r&egrave;glement en ligne des litiges&nbsp;: 
                <a 
                  href="https://ec.europa.eu/consumers/odr" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="text-[hsl(211,100%,50%)] dark:text-[hsl(211,100%,55%)] hover:underline"
                >
                  https://ec.europa.eu/consumers/odr
                </a>.
              </p>
              <p className="mt-2">
                <span className="text-foreground font-medium">Pour les clients professionnels&nbsp;:</span> en 
                cas de diff&eacute;rend, les parties s&rsquo;efforceront de trouver une solution amiable. 
                &Agrave; d&eacute;faut, le litige sera soumis aux tribunaux comp&eacute;tents de Paris.
              </p>
            </div>

            {/* Article 18 */}
            <div>
              <h2 className="text-foreground text-xl font-semibold mb-2">Article 18 &ndash; Droit applicable</h2>
              <p>
                Les pr&eacute;sentes CGV sont r&eacute;gies par le droit fran&ccedil;ais. En cas de 
                contradiction entre les pr&eacute;sentes CGV et des conditions particuli&egrave;res, 
                ces derni&egrave;res pr&eacute;vaudront.
              </p>
            </div>

            {/* Article 19 */}
            <div>
              <h2 className="text-foreground text-xl font-semibold mb-2">Article 19 &ndash; Modification des CGV</h2>
              <p>
                Le Prestataire se r&eacute;serve le droit de modifier les pr&eacute;sentes CGV &agrave; tout moment. 
                Les CGV applicables sont celles en vigueur au jour de la commande. Le Client est invit&eacute; 
                &agrave; consulter r&eacute;guli&egrave;rement cette page.
              </p>
            </div>

            {/* Contact */}
            <div className="pt-4 border-t border-border/50">
              <h2 className="text-foreground text-xl font-semibold mb-2">Contact</h2>
              <p>
                Pour toute question relative aux pr&eacute;sentes CGV, vous pouvez nous contacter&nbsp;:
              </p>
              <ul className="list-none space-y-1 mt-2">
                <li><span className="text-foreground font-medium">Email&nbsp;:</span> contact@fasttask.agency</li>
                <li><span className="text-foreground font-medium">Adresse&nbsp;:</span> La Marsa, Tunisie</li>
                <li><span className="text-foreground font-medium">T&eacute;l&eacute;phone&nbsp;:</span> +216 29 275 042 / +216 24 112 051</li>
              </ul>
            </div>

          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
}
